import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConsultaDocumentiFilterComponent } from './consulta-documenti-filter';

export const ConsultaDocumentiFilterModule: string = ng
    .module('consulta-documenti-filter', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('consultaDocumentiFilterComponent', ConsultaDocumentiFilterComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/consulta-documenti-filter/consulta-documenti-filter.module.ts